import { offerTypeFromJsonQuery } from './offerTypeFromJsonQuery';
import { IJsonQuery } from '../../api-models/common/json_query';
import { isHotel } from '../category';

// Хак для отелей, они хранятся в RentDaily и отображаются только с параметром show_hotels=true
export function checkIsHotelsSearch(jsonQuery: IJsonQuery) {
  const offerType = offerTypeFromJsonQuery(jsonQuery);

  return isHotel(offerType);
}
